<template>
  <IndexPageSection
    v-if="displayableBookmark"
    :link-string="'一覧へ'"
    :link-url="'/mypage/item_sku_bookmarks'"
    :need-to-move-link-to-bottom="false"
    :section-name="'item-sku-bookmark'"
    :title="'ブックマークしたギフト'"
    @click-link="onClickSectionHeaderLink"
  >
    <div class="special-feature__lead">
      <div class="item-sku-bookmark__items">
        <div class="item-sku-bookmark__horizontal-scroll">
          <HorizontalScroll
            ref="item-sku-bookmark-horizontal"
            ref-name="item-sku-bookmark"
          >
            <ItemSkuBoxes
              :item-skus="bookmarkItems"
              :scrollable="false"
              @clicked-link="clickItemLink"
              @clicked-add-button="clickAddButton"
              @mount="onMountItemBoxes"
            />
          </HorizontalScroll>
        </div>
      </div>
    </div>
  </IndexPageSection>
</template>
<script>
import IndexPageSection from './IndexPageSection.vue'
import ItemSkuBoxes from '../../../molecules/item_boxes/ItemSkuBoxes.vue'
import axios from 'axios'
import HorizontalScroll from '../../../molecules/horizontal-scrolls/HorizontalScroll.vue'
export default {
  components: { IndexPageSection, ItemSkuBoxes, HorizontalScroll },
  data() {
    return {
      bookmarkItems: []
    }
  },
  computed: {
    displayableBookmark() {
      return this.bookmarkItems.length !== 0
    }
  },
  mounted() {
    this.getBookmarkItems()
  },
  methods: {
    onClickSectionHeaderLink() {
      dataLayer.push({
        event: 'click_top__bkmk_list'
      })
    },
    async getBookmarkItems() {
      try {
        const res = await axios.get(
          '/api/v1/users/@me/item_sku_bookmarks?limit=30'
        )
        this.bookmarkItems = res.data.data
          .map(itemSkus => itemSkus.attributes)
          .map(itemSku => ({
            id: itemSku.itemSkuId,
            linkUrl: itemSku.linkUrl,
            imageUrl: itemSku.imageUrl,
            brandName: itemSku.brandName,
            itemId: itemSku.itemId,
            itemName: itemSku.itemName,
            itemSkuName: itemSku.itemSkuName,
            itemSkuPrice: itemSku.price.toLocaleString(),
            isIncludingTax: itemSku.isIncludedTax,
            hasMultipleItemSkus: itemSku.hasMultipleItemSkus,
            addButtonText: 'ギフトを贈る',
            soldOut: itemSku.outOfStock
          }))
      } catch (error) {
        const errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : '情報の取得に失敗しました。しばらく経ってから再度アクセスしてください'
        this.$emit('error', errorMessage)
      }
    },
    clickItemLink(itemSkuId) {
      dataLayer.push({
        event: 'click_top__bkmk_item_detail',
        item_sku_id: itemSkuId
      })
    },
    async clickAddButton(itemId, itemSkuId) {
      event.stopPropagation()
      dataLayer.push({
        event: 'add_to_cart',
        item_sku_id: itemSkuId,
        item_list_name: 'top_bookmark_item'
      })

      try {
        await axios.post('/api/v1/pickup/gift_card_session_item_sku_contents', {
          item_sku_form: {
            item_id: itemId,
            item_sku_id: itemSkuId
          }
        })
        location.href = '/gift_card/edit'
      } catch (error) {
        const errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : '情報の取得に失敗しました。しばらく経ってから再度アクセスしてください'
        this.$emit('error', errorMessage)
      }
    },
    onMountItemBoxes() {
      this.$refs['item-sku-bookmark-horizontal'].initializeValues()
    }
  }
}
</script>
